// src/components/doctor/ConfirmSignDialog.jsx
//
// The confirmation in front of "Sign & complete". Both the header button and the
// Review step open this same dialog, which then runs the one sign sequence in
// useConsultation (autosave → save prescription → sign prescriptions → sign visit).

import React, { useEffect, useRef } from 'react';
import useDialogFocus from '../../hooks/useDialogFocus';

export default function ConfirmSignDialog({ busy, diagnosis, problem, onCancel, onConfirm }) {
  const confirmRef = useRef(null);
  const dialogRef = useRef(null);
  useDialogFocus(dialogRef);
  useEffect(() => { confirmRef.current?.focus(); }, []);
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape' && !busy) onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [busy, onCancel]);
  return (
    <div className="dialog-backdrop" onMouseDown={e => { if (e.target === e.currentTarget && !busy) onCancel(); }}>
      <div className="dialog" role="dialog" aria-modal="true" aria-labelledby="sign-title" ref={dialogRef}>
        <div className="dialog-title" id="sign-title">Sign &amp; complete this visit?</div>
        <div className="dialog-sub">
          Signing locks the diagnosis, advice, next steps and any prescription. The patient will be able to see the
          advice, the prescription and the next steps. Your private notes stay private.
        </div>
        <div className="field-group"><div className="field-label">Diagnosis</div><div className="field-text">{diagnosis}</div></div>
        {problem && <div className="alert alert-error" role="alert"><div className="grow">{problem}</div></div>}
        <div className="dialog-actions">
          <button type="button" className="btn btn-secondary" disabled={busy} onClick={onCancel}>Keep editing</button>
          <button type="button" ref={confirmRef} className="btn btn-primary" disabled={busy} onClick={onConfirm}>
            {busy ? 'Signing…' : problem ? 'Try again' : 'Sign & complete'}
          </button>
        </div>
      </div>
    </div>
  );
}
